import { useClipShareContext } from '../context/ClipShareContext';

export const useClipShare = () => {
  const context = useClipShareContext();
  
  return {
    // State
    currentView: context.state.currentView,
    sessionMode: context.state.sessionMode,
    sessionCode: context.state.sessionCode,
    userNickname: context.state.userNickname,
    userId: context.state.userId,
    isHost: context.state.isHost,
    participants: context.state.participants,
    messages: context.state.messages,
    clipboardMonitorActive: context.state.clipboardMonitorActive,
    chatMode: context.state.chatMode,
    contextMenu: context.state.contextMenu,
    connectionStatus: context.state.connectionStatus,
    
    // Actions
    setView: (view: any) => context.dispatch({ type: 'SET_VIEW', payload: view }),
    setSessionMode: (mode: any) => context.dispatch({ type: 'SET_SESSION_MODE', payload: mode }),
    setUserNickname: (nickname: string) => context.dispatch({ type: 'SET_USER_NICKNAME', payload: nickname }),
    toggleClipboardMonitor: () => context.dispatch({ type: 'TOGGLE_CLIPBOARD_MONITOR' }),
    setChatMode: (mode: 'auto' | 'manual') => context.dispatch({ type: 'SET_CHAT_MODE', payload: mode }),
    
    // Complex actions
    createSession: context.createSession,
    joinSession: context.joinSession,
    leaveSession: context.leaveSession,
    sendMessage: context.sendMessage,
    sendClipboardContent: context.sendClipboardContent,
    copyToClipboard: context.copyToClipboard,
    showContextMenu: context.showContextMenu,
    hideContextMenu: context.hideContextMenu,
    generateUserId: context.generateUserId,
    generateDefaultNickname: context.generateDefaultNickname
  };
};